<template>
  <div class="page-content--body">
    <div class="card--notify-block notify-orange mx-0 mb-5">
      Если нужна помощь в работе с оборудованием бренда STOUT, напишите свой вопрос в чат.<br />Специалист ответит Вам в рабочие дни с 10.00 до 18.00 по московскому времени.
    </div>
    <div class="page-content--body-right chat manager-chat">
      <div class="chat-wrap">
        <v-card id="tickets-list" class="chat--manager" outlined>
          <!--Блок с темами тикетов-->
          <v-list class="chat--manager-list" three-line>
            <v-list-item-group
              v-model="selectedQuestion"
              active-class="primary--text"
            >
              <template v-for="(item, key) in displayTickets">
                <v-list-item
                  :key="item.id"
                  :class="`chat--manager-list--point ${
                    getUnreadMessagesCount(item) ? 'chat--new-message' : ''
                  }`"
                  @click="OpenTicket(item)"
                >
                  <template v-slot:default="{ active }">
                    <div class="chat--manager-list--info">
                      <div
                        class="chat--manager-list--info-name"
                        v-html="item.title"
                      ></div>
                      <div
                        class="chat--manager-list--info-theme"
                        v-html="item.topic_name"
                      ></div>
                      <div v-html="item.subtitle"></div>
                      <div
                        :style="`${
                          item.lastMessage.message ? 'max-height:35px' : ''
                        }`"
                        class="chat--manager-list--info-position"
                        v-html="item.lastMessage.message"
                      ></div>
                      <div class="chat--manager-list--info-time">
                        <v-tooltip color="primary" right>
                          <template v-slot:activator="{ on, attrs }">
                            <div v-bind="attrs" v-on="on">
                              <v-icon color="#8F95B2" size="16"
                                >mdi-clock-outline</v-icon
                              >
                              {{ item.lastMessage.created }}
                            </div>
                          </template>
                          <span>Последнее сообщение</span>
                        </v-tooltip>
                      </div>
                      <div class="chat--manager-list--info-num">
                        <v-tooltip
                          v-if="getUnreadMessagesCount(item)"
                          color="primary"
                          right
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-chip
                              v-bind="attrs"
                              v-on="on"
                              class="chat--new-message-label"
                              >+{{ getUnreadMessagesCount(item) }}
                            </v-chip>
                          </template>
                          <span>Новые сообщения</span>
                        </v-tooltip>
                        <v-tooltip v-else color="primary" right>
                          <template v-slot:activator="{ on, attrs }">
                            <v-chip v-bind="attrs" v-on="on">{{
                              item.messages.length
                            }}</v-chip>
                          </template>
                          <span>Количество сообщений</span>
                        </v-tooltip>
                      </div>
                      <div
                        :class="`chat--manager-list--info-label ${
                          item.status === 'new' ? 'status-open' : 'status-close'
                        }`"
                      >
                        <template v-if="item.status === 'new'"
                          >Открыто</template
                        >
                        <template v-else>Закрыто</template>
                      </div>
                    </div>
                  </template>
                </v-list-item>
              </template>
            </v-list-item-group>
          </v-list>
          <v-btn
            class="btn-blue btn-small"
            color="primary"
            @click="OpenNewTicketForm"
          >
            Новое обращение <v-icon class="ml-2">mdi-plus</v-icon>
          </v-btn>
        </v-card>

        <!--Блок с сообщениями тикетов-->
        <div class="chat--action">
          <div class="chat--action-head">
            <div class="chat--action-head-avatar">
              <div
                v-if="ticket"
                class="chat--action-head-avatar-name"
                v-html="ticket.title"
              ></div>
            </div>
            <div class="chat--action-head-buttons">
              <v-btn class="mx-1" color="#fff" elevation="0" fab small>
                <v-icon color="#8F95B2">mdi-dots-vertical</v-icon>
              </v-btn>
            </div>
          </div>

          <div
            v-if="ticket === null || ticket === undefined"
            class="chat--action-body empty"
          >
            <v-icon size="40">mdi-forum</v-icon>
            <div class="mb-3">Пожалуйста, выберите диалог из списка или</div>
            <v-btn
              class="btn-small btn-blue"
              color="primary"
              @click="OpenNewTicketForm"
            >
              Создайте новый
              <v-icon class="ml-2">mdi-plus</v-icon>
            </v-btn>
          </div>

          <div v-if="ticket" id="messageContainer" class="chat--action-body">
            <div
              v-for="message in ticket.messages"
              :key="message.id"
              :class="`${message.admin_id ? 'manager' : 'justify-end user'} ${
                !message.readed ? 'unread' : ''
              }`"
              class="d-flex flex-row"
            >
              <template v-if="message.admin_id">
                <div class="manager-avatar">
                  <img alt="" src="/static/avatar_admin.png" />
                </div>
                <div class="manager-message-info">
                  <div v-html="message.userFromName" class="manager-name"></div>
                  <div class="message">
                    <div v-html="message.message"></div>
                    <div v-if="message.file_url" class="message-file">
                      <a
                        v-if="CheckPDF(message.file_url)"
                        :href="message.file_url"
                        target="_blank"
                      >
                        <font-awesome-icon
                          icon="file-pdf"
                          class="big-pdf pa-1"
                        />
                      </a>
                      <img
                        v-else
                        @click="OpenFile(message.file_url)"
                        class="tickets__item-file"
                        :src="message.file_url"
                      />
                    </div>
                    <div class="message-date">{{ message.created }}</div>
                  </div>
                </div>
              </template>
              <div v-else class="message">
                <div v-html="message.message"></div>
                <div v-if="message.file_url" class="message-file">
                  <a
                    v-if="CheckPDF(message.file_url)"
                    :href="message.file_url"
                    target="_blank"
                  >
                    <font-awesome-icon class="big-pdf pa-1" icon="file-pdf" />
                  </a>
                  <img
                    v-else
                    :src="message.file_url"
                    class="tickets__item-file"
                    @click="OpenFile(message.file_url)"
                  />
                </div>
                <div class="message-date">{{ message.created }}</div>
              </div>
            </div>
            <v-spacer></v-spacer>
          </div>

          <div v-if="ticket" class="chat--action-footer">
            <div class="d-flex flex-row align-center">
              <v-text-field
                v-model="message"
                append-icon="mdi-send"
                dense
                hide-details
                outlined
                placeholder="Ваше сообщение"
                @focus="PublishChatReaded"
                @keypress.enter="PostMessage()"
                @click:append="PostMessage()"
              ></v-text-field>

              <div v-if="document.base64" class="file-preview">
                <v-icon class="file-preview--delete" @click="DeleteDocument"
                  >✖</v-icon
                >
                <font-awesome-icon
                  v-if="CheckPDF(document.base64)"
                  class="big-pdf pa-1"
                  icon="file-pdf"
                />
                <div v-else class="file">
                  <img v-if="document.base64" :src="document.base64" />
                </div>
              </div>

              <image-uploader
                :autoRotate="true"
                :capture="false"
                :className="[
                  'fileinput',
                  { 'fileinput--loaded': document.name },
                ]"
                :debug="1"
                :maxWidth="1280"
                :preview="false"
                :quality="0.7"
                accept="image/*, application/pdf"
                doNotResize="['gif', 'svg', 'pdf']"
                outputFormat="verbose"
                @input="setImage"
                @onComplete="endImageResize"
                @onUpload="startImageResize"
              >
                <label
                  slot="upload-label"
                  class="upload-label--btn"
                  for="fileInput"
                >
                  <v-icon v-if="document.name">mdi-reload</v-icon>
                  <v-icon v-else>mdi-paperclip</v-icon>
                </label>
              </image-uploader>
            </div>
          </div>
        </div>

        <div class="formmaskview">
          <div class="formmaskview__loading-indicator"></div>
          <div class="formmaskview__child"></div>
        </div>

        <!-- File dialog -->
        <v-dialog
          v-model="openFileDialog"
          class="tickets__popup-dialog"
          content-class="tickets-dialog"
          hide-overlay
          max-width="980px"
          persistent
        >
          <v-card class="tickets__popup-card pa-0 transparent elevation-0">
            <v-btn
              class="tickets__popup-close"
              color="primary"
              dark
              fab
              x-small
              @click="openFileDialog = false"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
            <v-img
              :src="fileURL"
              aspect-ratio="2.75"
              class="tickets__popup-file"
              contain
              height="80vh"
            ></v-img>
          </v-card>
        </v-dialog>

        <!-- New ticket dialog -->
        <v-dialog v-model="dialog" max-width="800px" persistent>
          <v-card outlined>
            <v-card-title>
              <div class="card-title">Новое обращение</div>
              <v-spacer></v-spacer>
              <font-awesome-icon
                class="size-25 close-icon"
                icon="times"
                @click="CloseNewTicketForm"
              />
            </v-card-title>
            <v-card-text>
              <v-form
                autocomplete="off"
                @submit.prevent="AddNewTicket"
                class="auth-form feedback-ver"
              >
                <div
                  class="auth-form--wrap d-flex flex-wrap justify-space-between"
                >
                  <div class="auth-form--wrap w-100">
                    <div class="input-label">
                      Тема обращения <i class="color-red">*</i>
                    </div>
                    <v-select
                      :items="themes"
                      :menu-props="{ maxHeight: '400' }"
                      :rules="[rules.required]"
                      :value="theme"
                      outlined
                      dense
                      persistent-hint
                      required
                      @change="SetTopicID"
                    ></v-select>
                  </div>
                  <div class="auth-form--wrap w-100">
                    <div class="input-label">
                      Заголовок сообщения <i class="color-red">*</i>
                    </div>
                    <v-text-field
                      v-model="newTicket.title"
                      :rules="[rules.required]"
                      outlined
                      dense
                      required
                      type="text"
                    ></v-text-field>
                  </div>
                  <div class="auth-form--wrap w-100">
                    <div class="input-label">
                      Текст сообщения <i class="color-red">*</i>
                    </div>
                    <v-textarea
                      v-model="newTicket.comment"
                      :rules="[rules.required]"
                      outlined
                      dense
                      name="comment"
                      required
                    ></v-textarea>
                  </div>
                </div>
              </v-form>
              <small class="red--text"
                >*Все поля обязательны к заполнению</small
              >
            </v-card-text>
            <v-card-actions class="pa-3">
              <v-spacer></v-spacer>
              <v-btn
                :disabled="!validation"
                color="primary"
                class="btn-blue"
                @click="AddNewTicket()"
              >
                Отправить
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <div class="manager-info">
          <div class="manager-info--head">
            <div class="manager-info--head-img">
              <v-avatar rounded size="72">
                <v-icon size="70" color="black">mdi-account-tie</v-icon>
              </v-avatar>
            </div>
            <div class="manager-info--head-wrap">
              <div class="manager-info--head-name">
                {{ manager ? manager.full_name : "" }}
              </div>
              <div class="manager-info--head-function">
                Ваш персональный менеджер
              </div>
            </div>
          </div>
          <div class="manager-info--body">
            <v-expansion-panels multiple accordion v-model="panel">
              <v-expansion-panel class="manager-info--contacts">
                <v-expansion-panel-header>Информация</v-expansion-panel-header>
                <v-expansion-panel-content>
                  <!--                    <div class="manager-info&#45;&#45;contacts-location">Москва</div>-->
                  <a
                    :href="'tel:' + (manager ? manager.phone_mobile : '')"
                    class="manager-info--contacts-phone"
                    >{{ manager ? manager.phone_mobile : "" }}</a
                  >
                  <a
                    :href="'mailto:' + (manager ? manager.email : '')"
                    class="manager-info--contacts-mail"
                    >{{ manager ? manager.email : "" }}</a
                  >
                </v-expansion-panel-content>
              </v-expansion-panel>

              <!--                <v-expansion-panel class="manager-info&#45;&#45;attach">-->
              <!--                  <v-expansion-panel-header>Файлы (8)</v-expansion-panel-header>-->
              <!--                  <v-expansion-panel-content>-->
              <!--                    <div class="manager-info&#45;&#45;attach-files">-->
              <!--                      <div class="attach-file img">-->
              <!--                        <img alt="" src="@/assets/images/attach-img01.jpg" />-->
              <!--                      </div>-->
              <!--                      <div class="attach-file img">-->
              <!--                        <img alt="" src="@/assets/images/attach-img02.jpg" />-->
              <!--                      </div>-->
              <!--                      <div class="attach-file img">-->
              <!--                        <img alt="" src="@/assets/images/attach-img03.jpg" />-->
              <!--                      </div>-->
              <!--                      <div class="attach-file doc">-->
              <!--                        <span class="attach-file&#45;&#45;name">Resume.docx</span>-->
              <!--                        <span class="attach-file&#45;&#45;size">24 KB</span>-->
              <!--                      </div>-->
              <!--                      <div class="attach-file xls">-->
              <!--                        <span class="attach-file&#45;&#45;name">Report.xcel</span>-->
              <!--                        <span class="attach-file&#45;&#45;size">34 KB</span>-->
              <!--                      </div>-->
              <!--                    </div>-->
              <!--                  </v-expansion-panel-content>-->
              <!--                </v-expansion-panel>-->
            </v-expansion-panels>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ManagerChat',
  data() {
    return {
      panel: [0, 1],
      message: null,
      dialog: false,
      openFileDialog: false,
      fileURL: '',
      intervalId: null,
      document: {
        base64: '',
        name: '',
        filename: '',
        url: '',
      },
      errors: [],
      newTicket: {
        topic_id: '',
        title: '',
        comment: '',
        contact: 'chat',
      },
      theme: '',
      // contact_options: ['Чат', 'E-mail', 'Звонок'],
      contact: '',
      rules: {
        required: value => !!value || 'Поле должно быть заполнено',
      },
      fullChat: false,
      hasImage: false,
      selectedQuestion: false,
    };
  },
  watch: {
    user() {
      this.loadTickets();
    },
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
    tickets() {
      return this.$store.state.tickets.tickets;
    },
    displayTickets() {
      const topicIds = this.topic_options.map(el => el.id);
      return this.tickets.filter(el => topicIds.indexOf(el.topic_id) !== -1);
    },
    ticket() {
      return this.$store.state.tickets.ticket;
    },
    topic_options() {
      return this.$store.state.tickets.topic_options;
    },
    themes() {
      return (
        (this.topic_options.length
          && this.topic_options.map(item => item.name))
        || []
      );
    },
    validation() {
      return (
        this.newTicket.topic_id
        && this.newTicket.title
        && this.newTicket.contact
        && this.newTicket.comment
      );
    },
    manager() {
      return this.$store.state.user.personal_manager;
    },
  },
  methods: {
    addFile() {
      // eslint-disable-next-line no-alert
      alert('я еще не работаю');
    },
    /** Показать скрыть полный чат */
    ShowFullChat() {
      this.fullChat = !this.fullChat;
    },
    /** Открыть файл в тикете */
    OpenFile(file) {
      this.openFileDialog = true;
      this.fileURL = file;
    },
    /** проверка на тип файла прикрепленного к тикету */
    CheckPDF(file) {
      return file.indexOf('/pdf;') !== -1 || file.indexOf('.pdf') !== -1;
    },
    /** Счетчик непрочтенных сообщений */
    GetNewMessagesCounter(messages) {
      const newMessages = messages.filter(
        item => item.admin_id && !item.readed,
      );
      return newMessages.length ? newMessages.length : '';
    },
    /** Открыть сообщения тикета в левой части */
    OpenTicket(ticket) {
      const payload = {
        ticket_id: ticket.id,
        profile_id: this.user.profile_id,
      };
      this.$store.dispatch('tickets/SetTicket', payload).then(() => {
        // скроллим чат в самый низ
        const container = document.getElementById('messageContainer');
        if (container) {
          const lastChild = container.children[container.children.length - 1];
          if (lastChild) {
            container.scrollTop = lastChild.offsetTop;
          }
        }
      });
    },
    setImage(e) {
      if (e && e.dataUrl) {
        this.document = {
          id: null,
          name: e.info ? e.info.name : '',
          base64: e.dataUrl,
          filename: '',
          url: '',
        };
      } else {
        this.document = {
          filename: '',
          base64: '',
          name: '',
          url: '',
          id: null,
        };
      }
    },
    startImageResize() {
      this.$store.dispatch('SetLoading', true);
    },
    endImageResize() {
      this.$store.dispatch('SetLoading', false);
    },
    /** Открыть форму добавления обращения */
    OpenNewTicketForm() {
      this.dialog = true;
    },
    /** Скрыть форму добавления обращения */
    CloseNewTicketForm() {
      this.newTicket = {
        topic_id: '',
        title: '',
        comment: '',
        contact: 'chat',
      };
      this.dialog = false;
    },
    /** Удаление документа из списка прикрепленных файлов. */
    DeleteDocument() {
      this.document = { filename: '', base64: '', name: '', url: '' };
    },
    /** Добавить сообщение в тикет */
    PostMessage() {
      const app = this;
      const data = {
        message: app.message,
        file: app.document.base64,
        profile_id: app.user.profile_id,
        ticket_id: app.ticket.id,
      };
      app.$store.getters.axl
        .post('tickets/api/messages/add', data)
        .then((response) => {
          app.AddMessage(response.data.message);
          app.document.base64 && app.DeleteDocument();
          app.message = '';
          app.OpenTicket(app.ticket);
        })
        .catch((error) => {
          app.$store.dispatch('HandleError', error);
        });
    },
    AddMessage(message, incomming) {
      const app = this;
      incomming = incomming || null;
      app.ticket.messages.push(message);
      if (incomming) {
        app.ChatReaded(incomming);
        app.PublishChatReaded();
      }
    },
    /** Отправить признак прочитанности сообщения */
    PublishChatReaded() {
      const payload = {
        profile_id: this.user.profile_id,
        ticket_id: this.ticket.id,
      };
      this.$store.dispatch('tickets/ReadedTicket', payload);
    },
    /** Добавление нового тикета */
    SetTopicID(e) {
      const topicID = this.topic_options.filter(item => (e === item.name ? item.id : null));
      this.newTicket.topic_id = topicID[0] !== null ? topicID[0].id : '';
    },
    /** Установка типа обратной связи */
    // SetContact(e) {
    //   switch (e) {
    //     case 'E-mail': this.newTicket.contact = 'email'; break;
    //     case 'Звонок': this.newTicket.contact = 'phone'; break;
    //     default: this.newTicket.contact = 'chat';
    //   }
    // },
    /** Добавить новый тикет-обращение */
    AddNewTicket() {
      const app = this;
      const payload = {
        ...app.newTicket,
        profile_id: this.user.profile_id,
      };

      app.$store.getters.axl
        .post('tickets/api/tickets/send-ticket', payload)
        .then((response) => {
          app.$store.dispatch(
            'ShowInfo',
            'Обращение отправлено! Ожидайте ответ в ближайшее время',
          );
          console.log('AddNewTicket', response.data.ticket);
          app.OpenTicket(response.data.ticket);
          app.CloseNewTicketForm();
        })
        .catch((error) => {
          app.$store.dispatch('HandleError', error);
        });
    },
    loadTickets() {
      this.$store.dispatch('tickets/GetTickets', {
        profileId: this.user.profile_id,
        type: 'specialist',
      });
    },
    getUnreadMessagesCount(ticket) {
      return ticket.messages.filter(m => !m.readed && m.admin_id).length;
    },
  },
  created() {},
  mounted() {
    this.user && this.loadTickets();
    this.intervalId = setInterval(() => {
      this.user && this.loadTickets();
    }, 15000);
    this.$store.dispatch('tickets/UnsetTicket');
    this.user && this.ticket && this.PublishChatReaded();
    this.$store.dispatch('SetTitle', 'Чат с менеджером');
  },
  destroyed() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  },
};
</script>

<style lang="scss" src="./ManagerChat.scss" />
